module.exports = __webpack_public_path__ + "img/fi-rr-file-psd.550f2085.svg";